import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Fade, Zoom } from "react-reveal";
import { FaCode } from "react-icons/fa";
import { Link } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";

const projects = [

  {
    id:1,
    title: "BharatGenAi-Image",
    description: "BharatGenAi-Image Generator is a web application that allows users to generate images based on text prompts using an AI-powered API. Users can view, download, and interact with dynamically generated images in a seamless and responsive UI built using modern frontend technologies.",
    technologies:"Reactjs,Axios,API,Framer-Motion,TailwindCss",
    image: require("../../images/BharatGenAi-Image.png"),
    link: "https://bharatgenai-image-by-prasahant.netlify.app/"
  },

  {
    id: 2,
    title: "Bharat Store",
    description:
      "Bharat Store is an e-commerce web application offering a wide range of clothing options and all essential features expected in an online shopping platform.",
    technologies: "ReactJs, NodeJs, ExpressJs, MongoDb, TailwindCss",
    image: require("../../images/bharat_store.png"),
    link: "https://github.com/Prashant-Malviya/Bharat-Store",
  },
  {
    id: 3,
    title: "YouTube Web App",
    description:
      "The YouTube Web App is an advanced clone of the YouTube platform, featuring video listings, seamless playback, user profiles with uploaded videos, subscriber counts, and detailed engagement metrics like likes, comments, and views.",
    technologies: "ReactJs, TailwindCss, Rapid Api, Axios",
    image: require("../../images/youtube.png"),
    link: "https://youtube-app-by-prashant-malviya.netlify.app/",
  },
  {
    id: 4,
    title: "EduBharat",
    description:
      "EduBharat is a powerful e-learning platform connecting students and teachers. Students can access tutorials across categories, while teachers can upload and manage content with ease. Key features include category-based filtering, personalized recommendations, progress tracking, and intuitive dashboards, ensuring an efficient and engaging learning experience.",
    technologies: "ReactJs, TailwindCss, Rapid Api, Axios",
    image: require("../../images/edubharat.png"),
    link: "https://github.com/Prashant-Malviya/EduBharat",
  },
];

export default function Projects() {
  return (
    <div>
      <Container fluid className="certificate-section" id="about">
        <Container>
          <Row>
            <Col
              md={12}
              className="certificate-description d-flex justify-content-start"
            >
              <Zoom left cascade>
                <h1 className="aboutme-heading">Projects</h1>
              </Zoom>
            </Col>
            {projects.slice(0, 4).map((project) => (
              <Col md={3} key={project.id}>
                <Fade bottom>
                  <div
                    className="singleProject"
                    style={{
                      backgroundColor: "rgb(142 70 186 / 31%)",
                      border: "1px solid",
                    }}
                  >
                    <div className="projectContent">
                      <h5 style={{ color: "#fbd9ad" }}>{project.title}</h5>
                      <img src={project.image} alt={project.title} />
                      <div className="project--showcaseBtn">
                        <a
                          href={project.link}
                          target="_blank"
                          rel="noreferrer"
                          className={"iconBtn"}
                          aria-labelledby={`code-${project.id}`}
                        >
                          <FaCode
                            id={`code-${project.id}`}
                            className={"icon"}
                            aria-label="Code"
                          />
                        </a>
                      </div>
                    </div>
                    <h6>
                      <p
                        className="project--desc"
                        style={{
                          background: "#fbd9ad",
                          color: "#b061df",
                          fontWeight: 600,
                        }}
                      >
                        {project.description}
                      </p>
                    </h6>
                    <div
                      className="project--lang"
                      style={{
                        background: "#fbd9ad",
                        color: "#b061df",
                        fontWeight: 600,
                      }}
                    >
                      {project.technologies}
                    </div>
                  </div>
                </Fade>
              </Col>
            ))}
          </Row>
          <div className="blog--viewAll">
            <Link to="/projectspage">
              <button className="btn btn-primary">
                View All
                <HiArrowRight className="viewArr" />
              </button>
            </Link>
          </div>
        </Container>
      </Container>
    </div>
  );
}
